module.exports = __webpack_public_path__ + "img/04-1-1批处理.bfa88132.svg";